"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalMockDev = exports.LocalMock = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const local_mock_dev_component_1 = __importDefault(require("./local-mock-dev.component"));
var local_mock_component_1 = require("./local-mock.component");
Object.defineProperty(exports, "LocalMock", { enumerable: true, get: function () { return local_mock_component_1.LocalMock; } });
const LocalMockDev = (prop) => {
    return local_mock_dev_component_1.default && (0, jsx_runtime_1.jsx)(local_mock_dev_component_1.default, { ...prop });
};
exports.LocalMockDev = LocalMockDev;
//# sourceMappingURL=local-mock.container.js.map